
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Header } from 'components/header'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Trend-Artikel, Insta-Storys und ein Gespräch mit einer Bundesrätin' lead='Sie schrieben Artikel, drehten Videos, moderierten Radiosendungen und befragten fürs Fernsehen gar Simonetta Sommaruga: Insgesamt 250 Schülerinnen und Schüler nahmen an der dritten Schweizer Jugendmedienwoche YouNews teil.' mdxType="Header" />
    <p>{`«Die grosse Stärke von YouNews ist, dass in spannenden gemeinsamen Projekten Jugendliche und Journalismus-Profis voneinander lernen können», sagt Michael Marti, YouNews-Mitinitiator und Mitglied der Chefredaktion Tamedia. «Die Schülerinnen und Schüler sehen, wie viel Arbeit hinter gutem Journalismus steckt. Und wir Profis erfahren, wie Jugendliche sich informieren und was sie von traditionellen Medientiteln erwarten.»`}</p>
    <p>{`YouNews will Jugendliche nicht belehren und bevormunden. Die Schülerinnen und Schüler arbeiteten während der Woche vom 13. bis 19. Januar in den Redaktionen mit, Hand in Hand mit den Profis. Dabei sind unzählige originelle und spannende Storys entstanden, darunter auch viele Videos für den Insta-Channel `}<a parentName="p" {...{
        "href": "https://www.instagram.com/younews.ch/"
      }}>{`younews.ch`}</a>{` oder unter dem Hashtag `}<a parentName="p" {...{
        "href": "https://www.instagram.com/explore/tags/jugendmedienwoche/"
      }}>{`#younews2020`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;